import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';

class BestBuyEndpoint extends BaseEndpoint {
  constructor(config) {
    super('best-buy', config);
  }

  login() {
    const url = super.appendUrl('/login');
    return super.httpPOST({ url, body: {} });
  }
}

export class BestBuyClient extends BaseSDK {
  #bestbuy_endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.#bestbuy_endpoint = new BestBuyEndpoint(this.config);
  }

  login() {
    return this.#bestbuy_endpoint.login();
  }
}
